import { render, staticRenderFns } from "./XcxSubmit.vue?vue&type=template&id=f706ef3e&scoped=true"
import script from "./XcxSubmit.vue?vue&type=script&lang=js"
export * from "./XcxSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f706ef3e",
  null
  
)

export default component.exports